/**
 * Exhaustiveness guard for discriminated-union dispatch. Placed in a `default:`
 * (or final `else`) after every union member is handled, the `never` parameter
 * makes an unhandled member a compile error at the call site — so adding a new
 * variant fails the build at each dispatch that forgot it, instead of silently
 * falling through. Reaching it at runtime means malformed (out-of-union) data.
 */
export function assertNever(value: never, context = 'value'): never {
  throw new Error(`Unexpected ${context}: ${JSON.stringify(value)}`);
}
